import React from 'react'
import { Edit, useForm, ListButton } from '@refinedev/antd'
import { Form, Input } from 'antd'
import { IEcoGestRoom } from 'src/modules/Advices/EcoGestRooms/EcoGestRooms.d'
import { useParams } from 'react-router-dom'

/**
 * This function returns a view to edit eco gests tags.
 *
 * @returns View to Edit eco gests tags.
 */
export const EditEcoGestRooms = () => {
    const { id } = useParams()
    const { formProps, saveButtonProps } = useForm<IEcoGestRoom>({
        action: 'edit',
        resource: 'ecoGestRoom',
        id: id,
        queryOptions: {
            enabled: true,
        },
        meta: {
            operation: 'allEcoGestRooms', // the query operation
            fields: [
                {
                    edges: [
                        {
                            node: ['id', 'name', 'icon'],
                        },
                    ],
                },
            ],
        },
    })

    return (
        <Edit
            saveButtonProps={saveButtonProps}
            headerProps={{
                title: 'Détail de la pièce',
                extra: <ListButton resource="ecoGestRoom" />,
            }}
        >
            <Form
                {...formProps}
                layout="vertical"
                onFinish={(values) =>
                    formProps.onFinish?.({
                        ...values,
                    })
                }
            >
                <Form.Item label="Titre" name="name">
                    <Input />
                </Form.Item>
                <Form.Item label="Url de l'icône" name="icon">
                    <Input />
                </Form.Item>
            </Form>
        </Edit>
    )
}
